import React, { useState } from 'react';
import { Table, Button, Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SubscriptionItemsTable from './subscriptionItemsTable';

export default function SubscriptionList({ subscriptions, onEdit, markInactive, onAdd, loading }) {
  // Main table columns (Customer-level)
  const customerColumns = [
    {
      title: 'Customer',
      key: 'customer',
      render: (_, record) => {
        const { name, code } = record.customer;
        const split = String(name).split('\n');
        return split.map((line, idx) => {
          let lineItem = line;
          if (idx === split.length - 1) {
            lineItem = `${line} (${code})`
          }
          return <div key={idx}>{lineItem}</div>
        });
      },
    },
    {
      title: 'Customer Address',
      key: 'customer_address',
      render: (_, record) => {
        const { address, city, state, zip, country } = record.customer;
        return `${address}, ${city}, ${state}, ${zip}, ${country}`;
      },
    },
    {
      title: 'Subscribed Products',
      key: 'subscribed_products',
      render: (_, record) => {
        return record.subscription_items.length;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => {
        return <Button onClick={() => onEdit(record)}>Edit</Button>
      }
    },
  ];

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);


  return (
    <>
      <Row justify="end">
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD SUBSCRIPTION
          </Button>
        </Col>
      </Row>
      <Table
        rowKey="customer_id"
        columns={customerColumns}
        dataSource={subscriptions}
        loading={loading}
        scroll={{ x: 'max-content' }}
        expandable={{
          expandedRowRender: (record) => (
            <>
            <SubscriptionItemsTable
              markInactive={markInactive}
              customerId={record.customer_id}
              items={record.subscription_items}
            />
            </>
          ),
          expandRowByClick: true,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            setExpandedRowKeys(expanded ? [record.customer_id] : [])
          },
          rowExpandable: (record) => record.subscription_items.length > 0,
        }}
        pagination={subscriptions?.length > 10 || false}
      />
    </>
  );
}
